import React from "react";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { navbarLinks } from "./NavbarLinks";

interface NavbarLink {
    url: string;
    string: string;
}

interface NavbarLinksProps {
    activeKey: number;
}

const links: NavbarLink[] = navbarLinks;

export const NavbarLinks: React.FC<NavbarLinksProps> = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation('core');
    const { activeKey } = props;

    return (
        <Nav
            variant="pills"
            activeKey={activeKey}
            className='text-dark nav-text-size fw-normal text-uppercase d-none d-sm-inline-flex'
        >
            {links.map((link, index) => (
                <Nav.Item className='px-4' key={index}>
                    <Nav.Link
                        eventKey={index + 1}
                        href="#"
                        onClick={() => navigate(link.url)}
                        style={index + 1 !== activeKey ? { color: "#000000" } : undefined}
                    >
                        <b>{t(link.string)}</b>
                    </Nav.Link>
                </Nav.Item>
            ))}
        </Nav>
    );
};
